export const API_HOST = 'https://ipure.nfit.au.dk/vacancies/data.php';
export const GET_VACANCIES = 'GET_VACANCIES';
export const GET_AREAS = 'GET_AREAS';
export const GET_HOURS = 'GET_HOURS';
export const GET_LOCATIONS = 'GET_LOCATIONS';
export const SET_FILTER = 'SET_FILTER';
